import { Box, LoadingOverlay } from '@mantine/core';
import { useScreenSize } from '@/hooks';
import { HEADER_HEIGHT, SIDE_NAVBAR_WIDTH } from '@/constants';
import styles from './LoaderOverlay.module.sass';

export const LoaderOverlay = () => {
  const { isDesktop } = useScreenSize();

  return (
    <Box
      className={styles.overlay}
      style={{
        top: HEADER_HEIGHT,
        left: isDesktop ? `${SIDE_NAVBAR_WIDTH}px` : '0',
      }}
    >
      <LoadingOverlay visible={true} overlayProps={{ blur: 2 }} />
    </Box>
  );
};
